<template>
  <div class="col-md-6">
    <div class="panel panel-default">
      <div class="panel-title">
        <h3>Messagerie</h3>
        <button class="btn btn-sm btn-primary top-right m-b-15">Voir tout</button>
      </div>
      <div class="panel-body">
        <messenger-item v-for="n in 5"
                        :key="n"></messenger-item>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .panel {
    padding: 0 10px;
    .panel-title {
      position: relative;
      h3 {
        margin-top: 10px;
        margin-bottom: 10px;
        position: relative;
        &::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: -5px;
          display: inline-block;
          height: 2px;
          width: 40px;
          background: #fb557c;
        }
      }
      button {
        position: absolute;
        right: 5px;
      }
    }
    .panel-body {
      padding: 0;
    }
  }
</style>

<script type="text/babel">
  import MessengerItem from 'components/Dashboard/Messenger/MessengerItem'

  export default {
    name: "Messenger",

    components: {
      MessengerItem
    },

    data () {
      return {}
    },
  }
</script>



// WEBPACK FOOTER //
// client/components/Dashboard/Messenger/Messenger.vue